// store/cartStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
    persist(
        (set, get) => ({
            items: [],
            selectedDate: null, // Date commune pour tous les services

            // Ajouter un service au panier
            addToCart: (service, date, quantity = 1) => {
                set((state) => {
                    const existingItemIndex = state.items.findIndex(
                        item => item.service.id === service.id
                    );

                    if (existingItemIndex >= 0) {
                        // Mettre à jour la quantité si le service existe déjà
                        const updatedItems = [...state.items];
                        updatedItems[existingItemIndex].quantity += quantity;
                        return {
                            items: updatedItems,
                            selectedDate: date // Mettre à jour la date
                        };
                    } else {
                        // Ajouter un nouvel item
                        return {
                            items: [...state.items, { service, quantity }],
                            selectedDate: date // Définir la date
                        };
                    }
                });
            },

            // Supprimer un service du panier
            removeFromCart: (serviceId) => {
                set((state) => {
                    const updatedItems = state.items.filter(item => item.service.id !== serviceId);
                    // Si le panier devient vide, réinitialiser la date
                    const newDate = updatedItems.length === 0 ? null : state.selectedDate;
                    return {
                        items: updatedItems,
                        selectedDate: newDate
                    };
                });
            },

            // Modifier la quantité
            updateQuantity: (serviceId, newQuantity) => {
                if (newQuantity < 1) {
                    get().removeFromCart(serviceId);
                    return;
                }

                set((state) => ({
                    items: state.items.map(item =>
                        item.service.id === serviceId
                            ? { ...item, quantity: newQuantity }
                            : item
                    )
                }));
            },

            // Modifier la date du panier
            updateDate: (newDate) => {
                set({ selectedDate: newDate });
            },

            // Vider le panier
            clearCart: () => {
                set({ items: [], selectedDate: null });
            },

            // Vérifier si le panier a une date
            hasDate: () => {
                return get().selectedDate !== null;
            },

            // Vérifier si le panier est vide
            isEmpty: () => {
                return get().items.length === 0;
            },

            // Calculer le total
            getTotalPrice: () => {
                const { items } = get();
                return items.reduce((total, item) => {
                    return total + (item.service.price * item.quantity);
                }, 0);
            },

            // Calculer le nombre total d'items
            getTotalItems: () => {
                const { items } = get();
                return items.reduce((total, item) => total + item.quantity, 0);
            },

            // Formater les données pour l'API
            getReservationData: () => {
                const { items, selectedDate } = get();
                if (items.length === 0 || !selectedDate) return null;

                return {
                    serviceIds: items.map(item => ({
                        serviceId: item.service.id,
                        quantity: item.quantity
                    })),
                    date: selectedDate
                };
            }
        }),
        {
            name: 'cart-storage',
        }
    )
);

export default useCartStore;